export const SERVER_URL = "https://osr-manager-server.herokuapp.com";
export const HEROKU_URL = "https://osr-manager-server.herokuapp.com/";
export const STANDBY_URL = "http://localhost:4000";
